import { render } from "./pins.vue?vue&type=template&id=32071e13&scoped=true"
import script from "./pins.vue?vue&type=script&lang=js"
export * from "./pins.vue?vue&type=script&lang=js"

import "./pins.vue?vue&type=style&index=0&id=32071e13&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32071e13"]])

export default __exports__